__turbopack_context__.v({
  "body": "CSearch-module__R3bqqq__body",
  "card": "CSearch-module__R3bqqq__card",
  "cardLink": "CSearch-module__R3bqqq__cardLink",
  "catalogItem": "CSearch-module__R3bqqq__catalogItem",
  "catalogLink": "CSearch-module__R3bqqq__catalogLink",
  "catalogList": "CSearch-module__R3bqqq__catalogList",
  "empty": "CSearch-module__R3bqqq__empty",
  "form": "CSearch-module__R3bqqq__form",
  "formLabel": "CSearch-module__R3bqqq__formLabel",
  "formRow": "CSearch-module__R3bqqq__formRow",
  "input": "CSearch-module__R3bqqq__input",
  "list": "CSearch-module__R3bqqq__list",
  "results": "CSearch-module__R3bqqq__results",
  "root": "CSearch-module__R3bqqq__root",
  "section": "CSearch-module__R3bqqq__section",
  "sectionTitle": "CSearch-module__R3bqqq__sectionTitle",
  "snippet": "CSearch-module__R3bqqq__snippet",
  "submit": "CSearch-module__R3bqqq__submit",
  "summary": "CSearch-module__R3bqqq__summary",
  "thumb": "CSearch-module__R3bqqq__thumb",
  "thumbWrap": "CSearch-module__R3bqqq__thumbWrap",
  "title": "CSearch-module__R3bqqq__title",
  "wrongWords": "CSearch-module__R3bqqq__wrongWords",
});
